<template>
  <WidthDimensionLine :y="22" :x1="18" :x2="25" />
  <WidthDimensionLine :y="22" :x1="28" :x2="33" />
  <HeightDimensionLine :y1="12" :x="52" :y2="48" />
  <HeightDimensionLine :y1="25" :x="66.4" :y2="82" />
</template>
